<template>
  <DropdownTooltip
    theme="info-tooltip"
    :distance="8"
    :triggers="['hover']"
    :popperShowTriggers="['hover']"
    placement="bottom-center"
    popperClass="reference-user__tooltip-popper"
    :tabIndex="-1"
    @click="openProfile"
  >
    <template #tooltip-label>
      <slot />
    </template>
    <template #tooltip-content="{ hide }">
      <button
        v-click-outside="hide.bind()"
        class="reference-component__tooltip"
        type="button"
        @click="openProfile"
      >
        <Avatar
          :src="user?.picture?.pictureUrl"
          size="sm"
          class="reference-component__tooltip-avatar"
        />
        <span class="reference-component__tooltip-info">
          <BaseSubHeading
            size="medium"
            weight="400"
            class="reference-component__tooltip-username"
          >
            {{ user.username }}
          </BaseSubHeading>
        </span>
      </button>
    </template>
  </DropdownTooltip>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router"
import { directive as vClickOutside } from "click-outside-vue3"

import { Avatar } from "@/components/Avatar"
import DropdownTooltip from "@/components/Dropdown/DropdownTooltip.vue"

import { User } from "@/models"

defineOptions({ name: "UserReferenceTooltip" })

const props = defineProps<{
  user: User
}>()

const route = useRoute()
const router = useRouter()

function openProfile() {
  const { href } = router.resolve({
    name: "edit-user",
    params: { accountId: route.params.accountId, userId: props.user.id }
  })
  window.open(href, "_blank")
}
</script>
